var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BBreadcrumb',{attrs:{"items":_vm.convertedItems}})}
var staticRenderFns = []

export { render, staticRenderFns }